var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "features-section-wrapper" }, [
    _c("div", { staticClass: "text-center" }, [
      _c("h1", { staticClass: "font-outfit-semi-bold" }, [
        _vm._v(" " + _vm._s(_vm.$t("pages.pricing.textVideo.title")) + " "),
      ]),
    ]),
    _c("div", { staticClass: "text-center" }, [
      _c(
        "p",
        { staticClass: "font-outfit-medium features-section-description" },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("pages.pricing.textVideo.description")) + " "
          ),
        ]
      ),
    ]),
    _c(
      "div",
      { staticClass: "all-cards-wrapper" },
      [
        _vm._l(_vm.getFeaturesData, function (feature) {
          return [
            _c("feature-section-card", {
              key: feature.name,
              attrs: {
                "class-color": feature.classColor,
                icon: feature.icon,
                name: _vm.$t(feature.name),
                title: _vm.$t(feature.title),
                description: _vm.$t(feature.description),
                "video-name": feature.videoName,
                reverse: feature.reverse,
              },
            }),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }